import { formatLocalDateTime } from '../../utils/formatTimestamp';

export const SCANNER_PROVIDERS = [
  { value: '', label: 'Auto-detect' },
  { value: 'greenhouse', label: 'Greenhouse' },
  { value: 'ashby', label: 'Ashby' },
  { value: 'lever', label: 'Lever' },
  { value: 'workday', label: 'Workday' },
];

export const emptyScanSource = { name: '', careers_url: '', provider: '', enabled: true };

export function parseRunSummary(summary) {
  if (!summary) return null;
  if (typeof summary === 'object') return summary;
  try {
    return JSON.parse(summary);
  } catch {
    return null;
  }
}

export function formatScannerDate(value) {
  return formatLocalDateTime(value);
}

export function runStatusClass(status) {
  if (status === 'completed') return 'success';
  if (status === 'running') return 'info';
  if (status === 'failed') return 'danger';
  return 'muted';
}
